import {ApplicationConfig} from '@angular/core';
import {provideRouter, withInMemoryScrolling} from '@angular/router';
import {routes} from "./app.routes";
import { provideHttpClient, withFetch } from "@angular/common/http";


export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes,

      // turn on auto scroll to top on route change
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
      })),
    provideHttpClient(
      withFetch(),
    )],
};
